import CryptoJS from "crypto"
/**
 * 从标准时间中取日期
 * @param { String } 标准时间
 */
export function getDate (params) {
  return typeof params === 'string' && params.split(' ')[0]
}

export function getObjectURL (file) {
  var url = null
  if (window.createObjectURL !== undefined) {
    url = window.createObjectURL(file)
  } else if (window.URL !== undefined) {
    url = window.URL.createObjectURL(file)
  } else if (window.webkitURL !== undefined) {
    url = window.webkitURL.createObjectURL(file)
  }
  return url
}

/**
 * 生成n位随机数
 * @param { Number }
 * @return { Number }
 */
export function RndNumber (n) {
  var rnd = ''
  for (var i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10)
  }
  return rnd
}

/**
 * 解析url 获取query
 * @param { Number }
 * @return { Object }
 */
export function parseUrl (url) {
  if (typeof url === 'string') {
    let arr = url.split('?')
    let temp = {}
    arr[1] && arr[1].split('&').forEach(v => {
      let u = v.split('=')
      let key = u[0]
      let value = decodeURIComponent(u[1])
      temp[key] = value
    })
    temp.path = arr[0]
    return temp
  }
}

/**
 * / 字节转兆
 * @param { Number }
 * @return { Number }
 */
export function getSize (val) {
  return val && (val / 1024 / 1024).toFixed(2)
}

/**
 * 获取文件的后缀名
 * @param name
 * @returns {string}
 */
export function getFileSuffix (name) {
  let result = ''
  let arr = name.split('.')
  if (arr.length > 1) {
    result = arr[arr.length - 1]
  }
  return result
}

/**
 * 字节转换成 KB MB等,不保留小数
 * @param bytes
 * @returns {*}
 */
export function bytesToSize (bytes) {
  if (bytes === 0) return '0 B'
  let k = 1024
  let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let i = Math.floor(Math.log(bytes) / Math.log(k))
  return (bytes / Math.pow(k, i)).toFixed(0) + ' ' + sizes[i]
}

export function getBrowser () {
  let ua = window.navigator.userAgent.toLowerCase()
  let reg = {
    ie: /rv:([\d.]+)\) like gecko/,
    firfox: /firefox\/([\d.]+)/,
    chrome: /chrome\/([\d.]+)/,
    opera: /opera.([\d.]+)/,
    safari: /version\/([\d.]+).*safari/
  }
  for (var key in reg) {
    if (ua.match(reg[key])) {
      return key
    }
  }
}

/**  
 * 解密后端加密返回的oss key等信息
 * @param { String } params 包含解密信息的对象，解密信息至少包括encrypt字段，也可能包含 iv,key等解密核心信息
 * 解密时候用的两个核心内容iv,key说明:
 * { String } iv AES加/解密的初始化向量，核心最大16位
 * { String } key 加密秘钥， key iv 和data必须匹配否则会报错
 * @returns {Object} 解密后的对象数据，如果解密失败返回 {}
 */
export function getDecryptOSSData(params = {}) {
  try {
    if (!params.encrypt) {
      return {}
    }
    if (!params.iv) {
      params.iv = "f6d6ef28e28d1c12"
    }
    if (!params.key) {
      params.key = "eb8130ebc4ed1984529011f193629007"
    }
    const crypto = CryptoJS
    const { iv, key, encrypt } = params
    const decipher = crypto.createDecipheriv(
      "aes-256-cbc",
      Buffer.from(key),
      Buffer.from(iv)
    )
    const decryptedstring = decipher.update(Buffer.from(encrypt, "base64"))
    const finalstring = Buffer.concat([decryptedstring, decipher.final()])
    const decryptData = finalstring.toString()
    return decryptData ? JSON.parse(decryptData) : {}
  } catch (err) {
    console.error("[utils/index.js] getDecryptOSSData :: error, ", err)
    return {}
  }
}
